import AnalyticsEvent from './AnalyticsEvent';
import { filterBlockedParams } from './FacebookAnalyticsConfig';

class FacebookAnalytics {
  static trackEvent = (event) => {
    if (event instanceof AnalyticsEvent) {
      const { meta, eventType } = event;
      const safeMeta = filterBlockedParams(meta);
      fbq('trackCustom', eventType, safeMeta);
    }
  };

  static logStandardEvent = (eventName, valueToSum, parameters) => {
  };

  static logPurchaseEvent = (purchaseAmount, currencyCode, parameters) => {
  };

  static logPixelStandardEvent = (eventName, params) => {
    const safeParams = filterBlockedParams(params);
    fbq('track', eventName, safeParams);
  }
}

export default FacebookAnalytics;
